import { render, staticRenderFns } from "./VeJwCjZfList.vue?vue&type=template&id=6b77bbdc&scoped=true"
import script from "./VeJwCjZfList.vue?vue&type=script&lang=js"
export * from "./VeJwCjZfList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b77bbdc",
  null
  
)

export default component.exports